import axios from 'services/axios-interceptors';
import { API_PATH } from 'store/service';

export const commonServices = {
  setCasls() {
    return axios.get(API_PATH + '/auth/get/privileges');
  }
};
